import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-primary/10 bg-white/95 backdrop-blur-sm shadow-card-medium transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-301" data-mp="2nvnf5h3e3ihq">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-302" data-mp="2swkt1hhd9qdf">
        <div data-id="element-303" data-mp="o0l1oi49o8ia">
          <p className="font-heading text-sm font-bold text-primary" data-id="element-304" data-mp="o133rvdm1gy4">17,99€</p>
          <p className="text-[11px] text-ink/60" data-id="element-305" data-mp="s26ksl7e9j0x">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" showArrow={false} href={CHECKOUT_URL} data-id="element-306" data-mp="s498uzozl230">
          Quiero la Enciclopedia
        </PrimaryButton>
      </div>
    </div>;
}